var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Spacer',[(_vm.data[_vm.data.type])?_c(_vm.components[_vm.data.type],{tag:"component",attrs:{"data":_vm.data[_vm.data.type],"caption":_vm.data.caption}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }